import React from "react";
import classNames from "classnames";
import styles from "./TabLayout.module.scss";

const TabColumnContent = React.memo(({children, className, style}) => {
    return <div className={classNames(styles['column-content'], className)} style={style}>
        {children}
    </div>
});

export default TabColumnContent;
